var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useAuth } from '@lucidhq/ui-auth';
import { FeatureFlagProvider } from './FeatureFlagProvider';
export var UiAuthFeatureFlagProvider = function (props) {
    var user = useAuth().user;
    var flagUser = {
        email: (user === null || user === void 0 ? void 0 : user.email) || '',
        name: (user === null || user === void 0 ? void 0 : user.name) || '',
        username: (user === null || user === void 0 ? void 0 : user.nickname) || '',
        picture: (user === null || user === void 0 ? void 0 : user.picture) || ''
    };
    return React.createElement(FeatureFlagProvider, __assign({}, props, { flagUser: flagUser }));
};
//# sourceMappingURL=UiAuthFeatureFlagProvider.js.map